import React, { Suspense } from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import LetterTile from '../letter-tile.jsx';
import MessagesUtil from "../../tinode/messagesUtils";
import * as MC_CONST from '../../tinode/constants'
import { IconClose, IconNotfoundSeen } from "../../icons/svg";
import lodash from 'lodash'
import { list } from "postcss";

const messages = defineMessages({
  seen_message_text: {
    id: "seen_message_text",
    defaultMessage: "Seen at ",
    description: "Seen at ",
  },
  seen_message_popup: {
    id: "seen_message_popup",
    defaultMessage: "Seen by",
    description: "See who has read the message",
  },
  received_message_text: {
    id: "received_message_text",
    defaultMessage: "Delivered at  ",
    description: "Delivered at  ",
  },
  notfound_seen_message_title: {
    id: "notfound_seen_message_title",
    defaultMessage: "No data",
    description: "No data"
  },
  notfound_seen_message_desc: {
    id: "notfound_seen_message_desc",
    defaultMessage: "No data. Please try again later",
    description: "No data. Please try again later"
  }
})

class SeenModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      listMember: [],
      loading: false,
      hasMore: true,
    };

    this.renderMember = this.renderMember.bind(this)
    this.getStatusTime = this.getStatusTime.bind(this);
    this.isCurrentDate = this.isCurrentDate.bind(this)
    this.convertHHmmDDMMYYYYFormat = this.convertHHmmDDMMYYYYFormat.bind(this)
    this.getHHmm24 = this.getHHmm24.bind(this)
    this.getStatusName = this.getStatusName.bind(this)
  }

  componentDidMount() {
    const messageContext = this.props.messageContext;
    const listMember = messageContext && messageContext.seen ? messageContext.seen : [];
    console.log(listMember)
    listMember.sort((a, b) => {
      const isASeen = a.delivered >= 0
      const isBSeen = b.delivered >= 0
      if (isASeen && !isBSeen) {
        return -1
      } else if (!isASeen && isBSeen) {
        return 1
      } else {
        return a.timestamp - b.timestamp
      }
    })
    this.setState({
      listMember,
    });
  }

  componentWillUnmount() { }

  getStatusTime = (time) => {
    const timeSendDate = time ? new Date(Number(time)) : null
    if (this.isCurrentDate(timeSendDate)) {
      return this.getHHmm24(timeSendDate)
    }
    return this.convertHHmmDDMMYYYYFormat(timeSendDate, '/', ',')
  }

  convertHHmmDDMMYYYYFormat = (time, dateSpliter, dateTimeSpliter) => {
    if (!time) return ''
    const dateTime = new Date(Number(time))
    const dateMonth = dateTime.getMonth() + 1
    const timeYear = dateTime.getFullYear()
    const timeMonth = dateMonth < 10 ? `0${dateMonth}` : dateMonth
    const timeDate = dateTime.getDate() < 10 ? `0${dateTime.getDate()}` : dateTime.getDate()
    const timeHour = dateTime.getHours() < 10 ? `0${dateTime.getHours()}` : dateTime.getHours()
    const timeMinute = dateTime.getMinutes() < 10 ? `0${dateTime.getMinutes()}` : dateTime.getMinutes()
    console.log();
    return `${timeHour}:${timeMinute} ${dateTimeSpliter} ${timeDate}${dateSpliter}${timeMonth}${dateSpliter}${timeYear}`
  }

  getHHmm24 = (time, spliter = ':') => {
    const dateTime = new Date(Number(time))
    const dateHour = dateTime.getHours()
    const dateMinute = dateTime.getMinutes()
    const timeHour = dateHour < 10 ? `0${dateHour}` : dateHour
    const timeMinute = dateMinute < 10 ? `0${dateMinute}` : dateMinute
    return `${timeHour}${spliter}${timeMinute}`
  }

  isCurrentDate = (time) => {
    const dateTime = new Date(Number(time))
    const now = new Date()
    if (now.getDate() !== dateTime.getDate() || now.getMonth() !== dateTime.getMonth() || now.getFullYear() !== dateTime.getFullYear()) {
      return false
    }
    return true
  }

  getStatusName = (delivered) => {
    const { formatMessage } = this.props.intl;
    if (delivered === MC_CONST.MESSAGE_DELIVERED.RECEIVED) {
      return formatMessage(messages.received_message_text)
    } else if (delivered === MC_CONST.MESSAGE_DELIVERED.SEEN_1_MESSAGE) {
      return formatMessage(messages.seen_message_text)
    } else if (delivered === MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES) {
      return formatMessage(messages.seen_message_text)
    }
    return formatMessage(messages.received_message_text)
  }

  renderMember(member) {
    const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, member.member)
    const topic = this.props.tinode.getTopicByName(topicId)
    const longSeen = member.timestamp;
    const timeSeen = this.getStatusTime(longSeen);
    const delivered = member.delivered;
    if (topic) {
      console.log('member.topic || member.user', topic.topic || topic.user);
      const name = topic.getTopicName();
      const avatar = lodash.has(topic, 'public.photo.ref') ? topic.public.photo.ref : true;
      return (
        <div className="seen-member-info" key={member.member}>
          <div className="seen-member-avatar" >
            <LetterTile
              tinode={this.props.tinode}
              avatar={avatar || true}
              title={name}
              topic={topic.topic || topic.user} />
          </div>
          <div className="seen-member-content">
            <div className="seen-member-name">{name}</div>
            <div className="seen-member-time">{this.getStatusName(delivered)}{` ${timeSeen}`}</div>
          </div>
        </div>
      )
    }

    return ''
  }

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <Suspense
        fallback={
          <div className="panel-form-row">
            <FormattedMessage
              id="loading_note"
              defaultMessage="Loading..."
              description="Message shown when component is loading"
            />
          </div>
        }
      >
        <div className="message-seen-by">
          <div className="header">
            <div className="title">{formatMessage(messages.seen_message_popup)}</div>
            <button className="done" onClick={this.props.onClose}>
              <IconClose />
            </button>
          </div>
          <div className="content">
            <div className="seen-member-container">
              {this.state.listMember.length > 0 ?
                <>
                  {this.state.listMember.map((member) => {
                    return this.renderMember(member);
                  })}
                </>
                :
                <div className="notfound-seen">
                  <div className="icon">
                    <IconNotfoundSeen />
                  </div>
                  <div className="title">
                    {formatMessage(messages.notfound_seen_message_title)}
                  </div>
                  <div className="desc">
                    {formatMessage(messages.notfound_seen_message_desc)}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </Suspense>
    );
  }
}
export default injectIntl(SeenModal);
